import componentMap from "./lookup.config.js";
import areaSelector from "./area-selector/index.js";
import locationSelector from "./location-selector/index.js";
import notAvailable from "./not-available/index.js";
import advancedSearch from "./advanced-search/index.js";
import customInput from "./custom-input/index.js";

export class Controller {
	constructor($scope, $element, dynamicComponent) {
		this._scope = $scope;
		this._element = $element;
		this._dynamicComponent = dynamicComponent;
	}

	$postLink() {
		this._element.addClass("input-group-btn");
		this.compile();
	}

	compile() {
		const lookupSettings = componentMap[this.lookup.name];
		const locals = {
			lookup: this.lookup
		};

		const scope = this._scope.$new();
		scope.onSelect = this.onSelect;

		const context = {};

		this._dynamicComponent.compile(
			lookupSettings,
			locals,
			scope,
			this._element,
			context
		);
	}
}

const deps = [areaSelector, notAvailable, advancedSearch, locationSelector, customInput];

export default angular
	.module("vesl.components.lookups.selection-lookup", deps)
	.component("selectionLookup", {
		controller: Controller,
		bindings: {
			lookup: "<",
			onSelect: "&"
		}
	}).name;
